
import MintPage from './mintpage'

export default MintPage;